<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Country Addtional Info</div>
        <div>
          <bread-crumb
            :bread-crumbs="['Country Setup', 'Country Additional']"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <div class="d-flex">
          <span class="d-flex">
            <country-flag :country="$route.query.iso3" />
            <p class="mt-2 ms-2">{{ $route.query.name }}</p>
          </span>
          <v-spacer></v-spacer>
          <span class="float-right">
            <v-btn
              depressed
              @click="goBack()"
              small
              class="text-capitalize"
              outlined
              color="primary"
              >Back</v-btn
            >
          </span>
        </div>
        <v-tabs
          color="primary"
          v-model="tabSeleted"
          grow
          slider-color="primary"
        >
          <v-tab
            v-for="item in items"
            :key="item.key"
            :href="'#' + item.key"
            :disabled="item.disabled"
            color="white"
            class="text-capitalize text-decoration-none"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabSeleted">
          <v-tab-item id="country">
            <AdditionalCountryInfoVue />
          </v-tab-item>

          <v-tab-item id="state">
            <stateDetailsVue />
          </v-tab-item>
          <v-tab-item id="city">
            <cityDetailsVue />
          </v-tab-item>
          <v-tab-item id="currency">
            <AllowedcurrencyVue />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import cityDetailsVue from "./Additionalcountry/cityDetails.vue";
import stateDetailsVue from "./Additionalcountry/stateDetails.vue";
import AllowedcurrencyVue from "./Additionalcountry/Allowedcurrency.vue";
import AdditionalCountryInfoVue from "./Additionalcountry/AdditionalCountryInfo.vue";
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
export default {
  name: "Country Additional",
  components: {
    Loading,
    stateDetailsVue,
    cityDetailsVue,
    AllowedcurrencyVue,
    AdditionalCountryInfoVue,
    BreadCrumb,
  },
  mixins: [alerts],
  data() {
    return {
      currentItem: "",
      loader: false,
      tabSeleted: 0,
      items: [
        { label: "Country Info", key: "country" },

        {
          label: "State Info",
          key: "state",
        },
        {
          label: "City Info",
          key: "city",
        },
        {
          label: "Allowed Currency",
          key: "currency",
        },
      ],
    };
  },

  methods: {
    goBack() {
      this.$router.push({
        name: "Country Setup",
        params: { name: this.$route.query.name, iso3: this.$route.query.iso3 },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
